import { SVGProps } from '../types';

const LightcoinIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M22.667 5.33331C28.5579 5.33349 33.333 10.1094 33.333 16.0003C33.3328 21.8911 28.5578 26.6661 22.667 26.6663C16.7761 26.6663 12.0002 21.8912 12 16.0003C12 10.1093 16.776 5.33331 22.667 5.33331ZM19.7715 16.7923L18.5176 17.2933L18.1416 18.6722L19.3945 18.1702L18.5176 21.555H27.166L27.668 19.5491H22.2773L23.0293 16.7923L24.5342 16.2903L24.9102 14.9124L23.4062 15.5384L24.5342 11.1517H21.2744L19.7715 16.7923Z"
      fill="#A5A8A9"
    />
  </svg>
);

export { LightcoinIcon };
